import React from 'react'
import about_image1 from "../../../assets/images/about/about-four-image1.png"
import about_info from "../../..//assets/images/about/about-info.png"
import about_image2 from "../../../assets/images/about/about-four-image2.png"
import about_user from "../../../assets/images/about/about-user.png"
import about_signature from "../../../assets/images/about/signature.png"


const AboutSection = () => {
  return (
    <>
      {/* About area start here */}
      <section className="about-section pt-120 pb-120 paralax__animation">
        <div className="container">
          <div className="row g-5">
            <div
              className="col-lg-6 image-column wow fadeInRight"
              data-wow-delay="200ms"
              data-wow-duration="1500ms"
            >
              <div className="inner-column">
                <div data-depth="0.01" className="image1 overlay-anim">
                  <img src={about_image1} alt="Image" />
                </div>
                <div className="info animation__arryLeftRight">
                  <img src={about_info} alt="Image" />
                </div>
                <div className="image2 overlay-anim" data-depth="0.05">
                  <img src={about_image2} alt="Image" />
                </div>
              </div>
            </div>
            <div className="col-lg-6 content-column">
              <div className="inner-column">
                <div className="content-box">
                  <div className="sec-title">
                    <h6
                      className="sub-title wow fadeInUp"
                      data-wow-delay="00ms"
                      data-wow-duration="1500ms"
                    >
                      ABOUT US
                    </h6>
                    <h2 className="title wow splt-txt" data-splitting>
                      The Foundation of Our Excellence
                    </h2>
                    <p
                      className="text wow fadeInUp"
                      data-wow-delay="200ms"
                      data-wow-duration="1500ms"
                    >
                      Pak Arab Inspection Limited Company is an independent inspection
                      and technical services provider delivering reliable
                      assessment, quality assurance, and safety solutions across
                      Saudi Arabia. We support industries with accurate data,
                      skilled professionals, and internationally recognized
                      standards to ensure operational integrity, compliance, and
                      long-term performance.
                    </p>
                  </div>
                  <div
                    className="about-block wow fadeInLeft"
                    data-wow-delay="00ms"
                    data-wow-duration="1500ms"
                  >
                    <div className="inner-box">
                      <div className="icon">
                        <svg
                          width={51}
                          height={55}
                          viewBox="0 0 51 55"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M3.80346 0.784813C1.98124 0.784813 0.498352 2.26681 0.498352 4.08903C0.498352 5.91125 1.98124 7.39414 3.80346 7.39414C5.31663 7.39414 6.58221 6.36547 6.97231 4.97431H17.3597C12.1976 7.3407 8.24056 11.8838 6.69799 17.5544C6.24199 19.194 6.01132 20.9245 6.01132 22.6986C6.01132 23.135 6.01756 23.7131 6.06654 24.3169C6.20013 25.8016 6.48335 27.2203 6.90195 28.5215C8.19157 32.7013 10.9222 36.3724 14.6005 38.8662C15.842 39.6846 16.6124 41.1916 16.6124 42.8V45.325C16.6124 45.8175 17.0105 46.2156 17.5031 46.2156H18.4391V51.2432C18.4391 52.8846 19.7742 54.2196 21.4147 54.2196H29.5977C31.2392 54.2196 32.5742 52.8846 32.5742 51.2432V46.2156H33.4889C33.9814 46.2156 34.3795 45.8175 34.3795 45.325V42.8107C34.3795 41.2085 35.1321 39.7122 36.3478 38.9018C40.0323 36.408 42.7879 32.7226 44.1087 28.526C44.5585 27.0965 44.8337 25.6733 44.9254 24.3223C44.9913 23.6391 45.0136 22.948 44.9913 22.2658C44.9468 20.6315 44.7125 19.0453 44.2939 17.5544C42.7362 11.9506 38.6794 7.34961 33.5281 4.97342H44.0303C44.4204 6.36369 45.6851 7.39325 47.1992 7.39325C49.0214 7.39325 50.5043 5.91036 50.5043 4.08814C50.5043 2.26592 49.0214 0.783922 47.1992 0.783922C45.6896 0.783922 44.4275 1.80725 44.0339 3.19217H28.6715C28.2796 1.80636 27.0167 0.78125 25.5062 0.78125C23.9957 0.78125 22.7248 1.80636 22.332 3.19217H6.96874C6.57509 1.80725 5.31307 0.784813 3.80346 0.784813ZM3.80346 5.61289C2.9636 5.61289 2.2796 4.92889 2.2796 4.08903C2.2796 3.24917 2.9636 2.56606 3.80346 2.56606C4.64332 2.56606 5.31841 3.24205 5.32554 4.07656C5.32554 4.07923 5.32376 4.08102 5.32376 4.08369C5.32376 4.08725 5.32554 4.09081 5.32554 4.09438C5.32287 4.93245 4.64154 5.61289 3.80346 5.61289ZM30.7912 51.2432C30.7912 51.9022 30.255 52.4384 29.596 52.4384H21.4129C20.7547 52.4384 20.2186 51.9022 20.2186 51.2432V46.2156H30.7903V51.2432H30.7912ZM42.5759 18.0344C42.9562 19.3873 43.1682 20.8283 43.2083 22.3183V22.3228C43.227 22.9302 43.2083 23.5456 43.1477 24.178C43.064 25.4133 42.8146 26.6958 42.4067 27.9925C41.207 31.808 38.6999 35.1585 35.3521 37.4242C33.626 38.574 32.5956 40.5886 32.5956 42.8116V44.4352H31.6978C31.6916 44.4352 31.6863 44.4317 31.6809 44.4317H26.3906V25.5967H29.905C30.3975 25.5967 30.7956 25.1986 30.7956 24.7061C30.7956 24.2136 30.3975 23.8155 29.905 23.8155H21.0941C20.6015 23.8155 20.2034 24.2136 20.2034 24.7061C20.2034 25.1986 20.6015 25.5967 21.0941 25.5967H24.6085V44.4317H19.3271C19.3208 44.4317 19.3155 44.4352 19.3101 44.4352H18.3919V42.8009C18.3919 40.6011 17.3142 38.5242 15.59 37.3859C12.2555 35.1264 9.77421 31.7919 8.59948 27.9854C8.21651 26.7991 7.9609 25.5112 7.83977 24.1646C7.80504 23.7496 7.7899 23.2971 7.7899 22.6986C7.7899 21.0857 7.9992 19.5164 8.41334 18.0273C10.2204 11.3859 15.6639 6.44563 22.4033 5.24684C22.4264 5.30919 22.4594 5.36619 22.4861 5.42586C22.5137 5.48731 22.5395 5.54877 22.5698 5.60755C22.6331 5.73045 22.7061 5.84623 22.7836 5.95934C22.8121 6.00031 22.8352 6.04395 22.8655 6.08314C22.9777 6.23098 23.1006 6.36903 23.236 6.4955C23.2654 6.52311 23.3001 6.54627 23.3304 6.57298C23.44 6.66828 23.554 6.75823 23.6751 6.83928C23.7285 6.87491 23.7846 6.90519 23.8399 6.93814C23.9476 7.00138 24.0589 7.05838 24.1738 7.10914C24.2362 7.13675 24.2985 7.16258 24.3626 7.18573C24.4856 7.23116 24.6111 7.26589 24.7394 7.29706C24.7991 7.31131 24.8569 7.32823 24.9175 7.33981C25.1081 7.37366 25.3023 7.39592 25.5018 7.39592C25.7004 7.39592 25.8936 7.37366 26.0833 7.33981C26.1448 7.32913 26.2036 7.31131 26.265 7.29617C26.3897 7.26589 26.5117 7.23205 26.6302 7.18841C26.7005 7.16258 26.7691 7.13408 26.8377 7.1038C26.9366 7.06016 27.031 7.01028 27.1245 6.95773C27.2002 6.91498 27.275 6.87402 27.3462 6.82592C27.4113 6.78228 27.4709 6.73241 27.5324 6.68342C27.9973 6.32183 28.3571 5.84713 28.5691 5.30206C28.5735 5.28959 28.5807 5.27891 28.586 5.26733C35.1918 6.44919 40.7555 11.4892 42.5742 18.0344H42.5759ZM47.1965 2.56606C48.0364 2.56606 48.7204 3.24917 48.7204 4.08903C48.7204 4.92889 48.0364 5.61289 47.1965 5.61289C46.3566 5.61289 45.6753 4.93067 45.6735 4.0917C45.6735 4.08903 45.6753 4.08725 45.6753 4.08458C45.6753 4.0828 45.6753 4.08191 45.6753 4.08013C45.6806 3.24472 46.3593 2.56606 47.1965 2.56606ZM25.5044 2.56339C26.3425 2.56339 27.0256 3.24561 27.0256 4.08369L27.0167 4.20214C26.9642 4.9948 26.2998 5.61556 25.5044 5.61556C24.6975 5.61556 24.0287 4.98945 23.9824 4.18878C23.9806 4.14692 23.9824 4.12466 23.9734 4.08369C23.9734 3.24561 24.6601 2.56339 25.5044 2.56339Z"
                            fill="black"
                          />
                        </svg>
                      </div>
                      <div className="content">
                        <h4 className="title">Engineering Expertise</h4>
                        <p className="text">
                          We deliver accurate inspection, testing, and
                          engineering solutions using skilled professionals,
                          advanced equipment, and proven methodologies.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    className="about-block wow fadeInLeft"
                    data-wow-delay="200ms"
                    data-wow-duration="1500ms"
                  >
                    <div className="inner-box">
                      <div className="icon">
                        <svg
                          width={43}
                          height={43}
                          viewBox="0 0 43 43"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M37.0891 13.1461L37.2094 13.0086L38.2922 11.9258L40.2516 9.96641C41.1453 9.07266 41.6438 7.88672 41.6438 6.63203C41.6438 5.37734 41.1453 4.19141 40.2516 3.29766L39.7016 2.74766C37.9141 0.960156 34.8203 0.960156 33.0328 2.74766L31.0735 4.70703L3.2297 32.5508L3.04064 32.7398L1.09845 41.9008L10.2594 39.9586L37.0891 13.1461ZM34.2531 3.95078C35.3875 2.83359 37.3469 2.81641 38.4813 3.95078L39.0485 4.51797C39.6156 5.08516 39.925 5.82422 39.925 6.63203C39.925 7.43984 39.6156 8.17891 39.0485 8.74609L37.0891 10.7055L32.2938 5.91016L34.2531 3.95078ZM31.0735 7.13047L32.861 8.91797L6.83907 34.9398L5.05157 33.1523L31.0735 7.13047ZM3.33282 39.6664L4.34689 34.8883L8.11095 38.6523L3.33282 39.6664ZM9.84689 37.9477L8.05939 36.1602L34.0813 10.1383L35.8688 11.9258L9.84689 37.9477ZM12.425 20.932L0.239075 8.74609L8.74689 0.238281L20.9328 12.4242L17.2375 16.0336L16.0172 14.8133L18.4406 12.3898L16.0172 9.94922L12.4078 13.5758L11.1875 12.3555L14.7969 8.74609L12.3734 6.30547L9.93283 8.74609L8.71251 7.52578L11.1531 5.08516L8.7297 2.66172L2.64532 8.74609L13.6281 19.7289L12.4078 20.932H12.425ZM42.761 34.2523L34.2531 42.7602L22.0672 30.5742L23.2875 29.3711L34.2531 40.3367L40.3375 34.2523L37.9141 31.8289L34.2875 35.4383L33.0672 34.218L36.6938 30.5914L34.2531 28.168L31.8297 30.5914L30.6094 29.3711L33.0328 26.9305L30.5922 24.507L26.9828 28.1164L25.7625 26.8961L30.5578 22.032L42.7438 34.218L42.761 34.2523Z"
                            fill="black"
                          />
                        </svg>
                      </div>
                      <div className="content">
                        <h4 className="title">Reliable & Compliant</h4>
                        <p className="text">
                          Our services follow international standards to ensure
                          safety, regulatory compliance, and consistent
                          performance across all projects.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="progress mt-30">
                  <div className="progress-single">
                    <h5 className="progress-title">Business Success</h5>
                    <div className="bar">
                      <div className="bar-inner count-bar" data-percent="80%">
                        <div className="count-text">88%</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="info mt-50">
                  <a href="/services" className="btn-two">
                    Find Services
                  </a>
                  <div className="user">
                    <div className="image">
                      <img src={about_user} alt="Image" />
                    </div>
                    <div>
                      <img style={{ width: "190px" }} src={about_signature} alt="Image" />
                      <p className="sub-title">Founder</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* About area end here */}
    </>
  );
}

export default AboutSection